import {
  Box,
  Paper,
  Typography,
  Divider,
  Grid,
  Hidden,
  Button,
  IconButton,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useContext, useRef } from "react";
import { AppDataContext } from "../../../common/appContext";
import shuttleRun from "../../../icons/icons-NBAblue/shuttle-run.png";
import proLane from "../../../icons/icons-NBAblue/pro-lane.png";
import threeFourRun from "../../../icons/icons-NBAblue/3-4-run.png";
import maxVertical from "../../../icons/icons-NBAblue/max-vert.png";
import standingVertical from "../../../icons/icons-NBAblue/no-step-vertical.png";
import { PlayerProfileService } from "./../../../services/playerProfile.Service";
import { Video_baseUrl } from "../../../services/AzureStorage";
import JWPlayer from "../../../sharedComponents/JWPlayer/JWPlayer";
import PlayerImg from "../../../images/novideo.png";
import PlayerProfileChart from "./PlayerProfileChart";
import PrimaryVideoImage from "../../../images/C3_B.png";
import SecondaryVideoImage from "../../../images/C3_G.png";
import CustomTooltip from "../../../common/CustomTooltip";
import PlayerProfileLineChart from "./PlayerProfileLineChart";
import CircularProgress from "@mui/material/CircularProgress";

//SERVICE APIs
import { gameScoreBaseUrl } from "../../../services/AzureStorage";
import PlayerProfileBarChartAnthro from "./PlayerProfileBarChartAnthro";
import VideoJS from "../../../sharedComponents/videoPlayer/VideoJS";

const useStyles2 = makeStyles((theme) => ({
  playerCombineInfo: {
    color: "#c8102e",
  },
  playerCombineValues: {
    color: "#000",
  },
  shuttleRunLeft: {},
  strengthAndAgilityContainer: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "25px",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px black",
    "&:hover": {
      backgroundColor: "white",
    },
  },
}));

export default function StrengthAndAgility(props) {
  const { playerID, styles } = props;
  const {
    user,
    selectedEventId,
    lengthUnits,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
  } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const [playerYear, setplayerYear] = useState([{}]);
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const classes2 = useStyles2();
  const [strengthAndAgilityData, setStrengthAndAgilityData] = useState([]);
  const [imagelefttrial, setimagelefttrial] = useState("");
  const [filelefttrial, setFilelefttrial] = useState("");
  const [imagerighttrial, setimagerighttrial] = useState("");
  const [filerighttrial, setFilerighttrial] = useState("");
  const [imagemaxvertical, setimagemaxvertical] = useState("");
  const [filemaxvertical, setFilemaxvertical] = useState("");
  const [imagestandingvertical, setimagestandingvertical] = useState("");
  const [filestandingvertical, setFilestandingvertical] = useState("");
  const [imageoprolane, setimageprolane] = useState("");
  const [fileprolane, setFileprolane] = useState("");
  const [imagethreefour, setimagethreefour] = useState("");
  const [filethreefour, setFilethreefour] = useState("");
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);

  //#Video Angles Data holders
  const [laneShuffleRightVideoAngle, setLaneShuffleRightVideoAngle] =
    useState("primary");
  const [laneShuffleLeftVideoAngle, setLaneShuffleLeftVideoAngle] =
    useState("primary");
  const [maxVerticalVideoAngle, setMaxVerticalVideoAngle] = useState("primary");
  const [noStepVerticalVideoAngle, setNoStepVerticalVideoAngle] =
    useState("primary");
  const [proLaneVideoAngle, setProLaneVideoAngle] = useState("primary");
  const [threeFourthVideoAngle, setThreeFourthVideoAngle] = useState("primary");

  const [strengthAndAgilityDataRanking, setStrengthAndAgilityDataRanking] =
    useState({});

  //#Counter Movement Data Holder
  const [counterMovement, setCounterMovement] = useState({});
  const [counterMovementUrl, setCounterMovementUrl] = useState("");

  //#Loader Data holders
  const [isCounterSectionLoading, setIsCounterSectionLoading] = useState(false);

  useEffect(() => {
    async function fetchDefaultCounterMovementUrl() {
      try {
        const { data } = await PlayerProfileService.getConterMovementUrl();
        setCounterMovementUrl(data[0]?.description || "");
      } catch (error) {
        console.error("Error fetching enumeration data:", error);
      }
    }
    fetchDefaultCounterMovementUrl();
  }, []);

  useEffect(() => {
    setEventId(selectedEventId);
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
  }, [selectedEventId]);

  useEffect(() => {
    PlayerProfileService.getPlayersStrengthAndAgilityData(
      eventId,
      playerID,
      user?.loginID
    ).then((response) => {
      if (Object.keys(response.data).length) {
        var leftdata = response.data.shuttleRunLeftJsonData;
        if (leftdata !== null) {
          var leftdata1 = JSON.parse(leftdata);
          setimagelefttrial(String(leftdata1.thumbnail));
        }
        var rightdata = response.data.shuttleRunRightJsonData;
        if (rightdata !== null) {
          var rightdata1 = JSON.parse(rightdata);
          setimagerighttrial(rightdata1.thumbnail);
        }

        var mvdata = response.data.maxVerticalJsonData;
        if (mvdata !== null) {
          var mvdata1 = JSON.parse(mvdata);
          setimagemaxvertical(mvdata1.thumbnail);
        }

        var svdata = response.data.standingVerticalJsonData;
        if (svdata !== null) {
          var svdata1 = JSON.parse(svdata);
          setimagestandingvertical(svdata1.thumbnail);
        }

        var prolanedata = response.data.proLaneJsonData;
        if (prolanedata !== null) {
          var prolanedata1 = JSON.parse(prolanedata);
          setimageprolane(prolanedata1.thumbnail);
        }

        var threefourdata = response.data.threeFourRunJsonData;
        if (threefourdata !== null) {
          var threefourdata1 = JSON.parse(threefourdata);
          setimagethreefour(threefourdata1.thumbnail);
        }
        setFilelefttrial(response.data.shuttleRunLeftFileName);
        setFilerighttrial(response.data.shuttleRunRightFileName);

        setFilemaxvertical(response.data.maxVerticalFileName);
        setFilestandingvertical(response.data.standingVerticalFileName);

        setFileprolane(response.data.proLaneFileName);
        setFilethreefour(response.data.threeFourRunFileName);

        setStrengthAndAgilityData(response.data);
      } else {
        setLoadingMessage("--");
      }
    });
    PlayerProfileService.getPlayersStrengthAndAgilityDataRanking(
      eventId,
      playerID,
      user?.loginID
    ).then((response) => {
      setStrengthAndAgilityDataRanking(response.data);
      if (Object.keys(response.data).length) {
        setStrengthAndAgilityDataRanking(response.data);
      } else {
      }
    });

    PlayerProfileService.getAnthrosDataByPlayerYear(eventId, playerID).then(
      (response) => {
        //console.log("setCombineYearDropdownData ", response.data);

        setplayerYear(response.data);
        var pdata = response.data;
        pdata.map((item, index) => {
          if (item.eventId === selectedEventId + "" && index == 0) {
            setbtn1(true); //btn1=true;
          } else if (item.eventId === selectedEventId + "" && index == 1) {
            setbtn2(true); // btn2=true;
          } else if (item.eventId === selectedEventId && index == 2) {
            setbtn3(true); // btn2=true;
          } else if (item.eventId === selectedEventId && index == 3) {
            setbtn4(true); //btn4=true;
          } else if (item.eventId === selectedEventId && index == 4) {
            setbtn5(true); // btn5=true;
          }
        });
      }
    );

    //#API call for getting the counter movement for player.
    GetCounterMovements();
  }, [eventId]);

  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }
    PlayerProfileService.getPlayersStrengthAndAgilityData(
      playerEventId,
      playerID,
      user?.loginID
    ).then((response) => {
      if (Object.keys(response.data).length) {
        var leftdata = response.data.shuttleRunLeftJsonData;
        if (leftdata !== null) {
          var leftdata1 = JSON.parse(leftdata);
          setimagelefttrial(String(leftdata1.thumbnail));
        }
        var rightdata = response.data.shuttleRunRightJsonData;
        if (rightdata !== null) {
          var rightdata1 = JSON.parse(rightdata);
          setimagerighttrial(rightdata1.thumbnail);
        }

        var mvdata = response.data.maxVerticalJsonData;
        if (mvdata !== null) {
          var mvdata1 = JSON.parse(mvdata);
          setimagemaxvertical(mvdata1.thumbnail);
        }

        var svdata = response.data.standingVerticalJsonData;
        if (svdata !== null) {
          var svdata1 = JSON.parse(svdata);
          setimagestandingvertical(svdata1.thumbnail);
        }

        var prolanedata = response.data.proLaneJsonData;
        if (prolanedata !== null) {
          var prolanedata1 = JSON.parse(prolanedata);
          setimageprolane(prolanedata1.thumbnail);
        }

        var threefourdata = response.data.threeFourRunJsonData;
        if (threefourdata !== null) {
          var threefourdata1 = JSON.parse(threefourdata);
          setimagethreefour(threefourdata1.thumbnail);
        }
        setFilelefttrial(response.data.shuttleRunLeftFileName);
        setFilerighttrial(response.data.shuttleRunRightFileName);

        setFilemaxvertical(response.data.maxVerticalFileName);
        setFilestandingvertical(response.data.standingVerticalFileName);

        setFileprolane(response.data.proLaneFileName);
        setFilethreefour(response.data.threeFourRunFileName);

        setStrengthAndAgilityData(response.data);
      } else {
        setLoadingMessage("--");
      }
    });
    PlayerProfileService.getPlayersStrengthAndAgilityDataRanking(
      playerEventId,
      playerID,
      user?.loginID
    ).then((response) => {
      setStrengthAndAgilityDataRanking(response.data);
      if (Object.keys(response.data).length) {
        setStrengthAndAgilityDataRanking(response.data);
      } else {
      }
    });
  };

  const getVideoAngleActionTrigger = (flag, primarykey, secondaryKey) => {
    try {
      const { name: primaryFileName, thumbnail: primaryThumbnail } = JSON.parse(
        strengthAndAgilityData[primarykey] || "{}"
      );

      const { name: secondaryFileName, thumbnail: secondaryThumbnail } =
        JSON.parse(strengthAndAgilityData[secondaryKey] || "{}");

      const fileData = {
        primaryFileName: primaryFileName || "",
        primaryThumbnail: primaryThumbnail || "",
        secondaryFileName: secondaryFileName || "",
        secondaryThumbnail: secondaryThumbnail || "",
      };

      switch (flag) {
        case "shuttleRunLeft":
          return {
            videoAngle: setLaneShuffleLeftVideoAngle,
            fileData: fileData,
            fileName: setFilelefttrial,
            imageName: setimagelefttrial,
          };
        case "shuttleRunRight":
          return {
            videoAngle: setLaneShuffleRightVideoAngle,
            fileData: fileData,
            fileName: setFilerighttrial,
            imageName: setimagerighttrial,
          };
        case "maxVertical":
          return {
            videoAngle: setMaxVerticalVideoAngle,
            fileData: fileData,
            fileName: setFilemaxvertical,
            imageName: setimagemaxvertical,
          };
        case "standingVertical":
          return {
            videoAngle: setNoStepVerticalVideoAngle,
            fileData: fileData,
            fileName: setFilestandingvertical,
            imageName: setimagestandingvertical,
          };
        case "proLane":
          return {
            videoAngle: setProLaneVideoAngle,
            fileData: fileData,
            fileName: setFileprolane,
            imageName: setimageprolane,
          };
        case "threeFourthRun":
          return {
            videoAngle: setThreeFourthVideoAngle,
            fileData: fileData,
            fileName: setFilethreefour,
            imageName: setimagethreefour,
          };
        default:
          break;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleVideoAngleClick = (angleType, flag, primarykey, secondaryKey) => {
    const result = getVideoAngleActionTrigger(flag, primarykey, secondaryKey);

    if (result) {
      //#Extracting properties from Trigger function.
      const { videoAngle, fileData, fileName, imageName } = result;

      //#Setting Local state of of specific click event target.
      videoAngle(angleType);

      //#setting File state based on video angle of specific click event target.
      if (angleType === "secondary") {
        fileName(fileData.secondaryFileName);
        imageName(fileData.secondaryThumbnail);
      } else if (angleType === "primary") {
        fileName(fileData.primaryFileName);
        imageName(fileData.primaryThumbnail);
      }
    }
  };

  const GetCounterMovements = async () => {
    setIsCounterSectionLoading(true);
    try {
      const result = await PlayerProfileService.getCounterMovementByPlayerId(
        eventId,
        0,
        playerID
      );

      setCounterMovement(result.data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsCounterSectionLoading(false);
    }
  };

  const handleExportCounterMovements = async (obj, iType) => {
    const {
      standingVertFile,
      standingVertDisplayFile = "default-standing-vert-display-file.xlsx",
      maxVerticalFile,
      maxVerticalDisplayFile = "default-max-vertical-display-file.xlsx",
    } = obj;

    const file = iType === 1 ? standingVertFile : maxVerticalFile;
    const displayName =
      iType === 1 ? standingVertDisplayFile : maxVerticalDisplayFile;

    const baseUrl = gameScoreBaseUrl(file);

    try {
      const response = await fetch(baseUrl);

      if (!response.ok) {
        throw new Error(
          `Failed to fetch data: ${response.status} ${response.statusText}`
        );
      }

      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = displayName;
      a.click();

      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box m={1} p={1}>
      <Grid container alignItems="center">
        <Grid item sm={4} xs={12}>
          <Typography
            noWrap
            pl={1}
            variant={styles.gridSectionTitle.variant}
            className={classes.gridSectionTitle}
          >
            Strength & Agility Summary
          </Typography>
        </Grid>
        <Grid item sm={8} xs={12}>
          {" "}
          <Box display="flex" alignItems={"center"} justifyContent="flex-end">
            {playerYear.length > 1
              ? playerYear.map((item, index) => {
                  if (index === 0) {
                    return (
                      <>
                        <Typography
                          variant="h6"
                          fontStyle="italic"
                          mr={2}
                          color={"primary"}
                        >
                          Details available for{" "}
                        </Typography>
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn1 === true
                              ? classes2.btnselected
                              : classes2.btnunselected
                          }
                        >
                          Year {item.eventYear}
                        </Button>
                      </>
                    );
                  } else if (index === 1) {
                    return (
                      <Button
                        onClick={() => getyearValue(item.eventId, index)}
                        key={index}
                        className={
                          btn2 === true
                            ? classes2.btnselected
                            : classes2.btnunselected
                        }
                      >
                        Year {item.eventYear}
                      </Button>
                    );
                  } else if (index === 2) {
                    return (
                      <Button
                        onClick={() => getyearValue(item.eventId, index)}
                        key={index}
                        className={
                          btn3 === true
                            ? classes2.btnselected
                            : classes2.btndeselected
                        }
                      >
                        Year {item.eventYear}
                      </Button>
                    );
                  } else if (index === 3) {
                    return (
                      <Button
                        onClick={() => getyearValue(item.eventId, index)}
                        key={index}
                        className={
                          btn4 === true
                            ? classes2.btnselected
                            : classes2.btnunselected
                        }
                      >
                        Year {item.eventYear}
                      </Button>
                    );
                  } else if (index === 4) {
                    return (
                      <Button
                        onClick={() => getyearValue(item.eventId, index)}
                        key={index}
                        className={
                          btn5 === true
                            ? classes2.btnselected
                            : classes2.btnunselected
                        }
                      >
                        Year {item.eventYear}
                      </Button>
                    );
                  } else {
                    return (
                      <Button
                        onClick={() => getyearValue(item.eventId, index)}
                        key={index}
                        className={
                          btn5 === true
                            ? classes2.btnselected
                            : classes2.btnunselected
                        }
                      >
                        {item.eventYear}
                      </Button>
                    );
                  }
                })
              : ""}
          </Box>{" "}
        </Grid>
      </Grid>

      <Box sx={{ margin: "10px 5px 0px 10px" }}>
        <Paper elevation={2} className={classes2.strengthAndAgilityContainer}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="shuttle-run-left"
                        src={shuttleRun}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Shuttle Run Left Trial Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.shuttleRunLeftTrialTime ===
                          null ||
                        strengthAndAgilityData.shuttleRunLeftTrialTime ===
                          "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.shuttleRunLeftTrialTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="shuttle-run-left"
                        src={shuttleRun}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Shuttle Run Left Laser Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.shuttleRunLeftLaserTime ===
                          null ||
                        strengthAndAgilityData.shuttleRunLeftLaserTime ===
                          "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.shuttleRunLeftLaserTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angles Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "shuttleRunLeft",
                                "shuttleRunLeftJsonData",
                                "shuttleRunLeftSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                laneShuffleLeftVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  laneShuffleLeftVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "shuttleRunLeft",
                                "shuttleRunLeftJsonData",
                                "shuttleRunLeftSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                laneShuffleLeftVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  laneShuffleLeftVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {filelefttrial === null || filelefttrial === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(filelefttrial)}
                            isAutoplay={false}
                            id="shuttleLeftTrial"
                            image={Video_baseUrl(imagelefttrial)}
                            fileName={filelefttrial}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityData.shuttleRunLeftLaserTime > 0
                                ? strengthAndAgilityDataRanking.shuttleRunLeftAgility
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpShuttleRunLeftAgility
                            }
                            chartName={"Lane Shuttle Left"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.shuttleRunLeftRank
                            }/${
                              strengthAndAgilityDataRanking.tcpShuttleRunLeft ??
                              0
                            }`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="shuttle-run-right"
                        src={shuttleRun}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Shuttle Run Right Trial Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.shuttleRunRightTrialTime ===
                          null ||
                        strengthAndAgilityData.shuttleRunRightTrialTime ===
                          "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.shuttleRunRightTrialTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="shuttle-run-right"
                        src={shuttleRun}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Shuttle Run Right Laser Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      sx={{ flex: "0 0 10%" }}
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.shuttleRunRightLaserTime ===
                          null ||
                        strengthAndAgilityData.shuttleRunRightLaserTime ===
                          "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.shuttleRunRightLaserTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angle Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "shuttleRunRight",
                                "shuttleRunRightJsonData",
                                "shuttleRunRightSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                laneShuffleRightVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  laneShuffleRightVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "shuttleRunRight",
                                "shuttleRunRightJsonData",
                                "shuttleRunRightSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                laneShuffleRightVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  laneShuffleRightVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {filerighttrial === null || filerighttrial === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(filerighttrial)}
                            isAutoplay={false}
                            id="righttrialrun"
                            image={Video_baseUrl(imagerighttrial)}
                            fileName={filerighttrial}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityData.shuttleRunRightTrialTime >
                              0
                                ? strengthAndAgilityDataRanking.shuttleRunRightAgility
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpShuttleRunRightAgility
                            }
                            chartName={"Lane Shuttle Right"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.shuttleRunRightRank
                            }/${
                              strengthAndAgilityDataRanking.tcpShuttleRunRight ??
                              0
                            }`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Paper elevation={2} className={classes2.strengthAndAgilityContainer}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="max-vertical-ft"
                        src={maxVertical}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Max Vertical{" "}
                        {getHandDimensionsUnitLabelType(lengthUnits)}
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.maxVerticalLeap === null ||
                        strengthAndAgilityData.maxVerticalLeap === "" ? (
                          "--"
                        ) : (
                          `${getHandDimensionsUnitValue(
                            strengthAndAgilityData.maxVerticalLeap
                          )}`
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angle Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "maxVertical",
                                "maxVerticalJsonData",
                                "maxVerticalSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                maxVerticalVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  maxVerticalVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "maxVertical",
                                "maxVerticalJsonData",
                                "maxVerticalSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                maxVerticalVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  maxVerticalVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {filemaxvertical === null || filemaxvertical === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(filemaxvertical)}
                            isAutoplay={false}
                            id="maxVertical"
                            image={Video_baseUrl(imagemaxvertical)}
                            fileName={filemaxvertical}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityData.maxVerticalLeap > 0
                                ? getHandDimensionsUnitValue(
                                    strengthAndAgilityDataRanking.maxVerticalLeapAgility
                                  )
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpMaxVerticalLeapAgility
                            }
                            chartName={"Max Vertical"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.maxVerticalLeapRank
                            }/${
                              strengthAndAgilityDataRanking.tcpMaxVerticalJump ??
                              0
                            }`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="standin-vertical-ft"
                        src={standingVertical}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Standing Vertical{" "}
                        {getHandDimensionsUnitLabelType(lengthUnits)}
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.standingVerticalLeap === null ||
                        strengthAndAgilityData.standingVerticalLeap === "" ? (
                          "--"
                        ) : (
                          `${getHandDimensionsUnitValue(
                            strengthAndAgilityData.standingVerticalLeap
                          )}`
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angle Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "standingVertical",
                                "standingVerticalJsonData",
                                "standingVerticalSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                noStepVerticalVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  noStepVerticalVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "standingVertical",
                                "standingVerticalJsonData",
                                "standingVerticalSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                noStepVerticalVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  noStepVerticalVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {filestandingvertical === null ||
                        filestandingvertical === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(filestandingvertical)}
                            isAutoplay={false}
                            id="standingVertical"
                            image={Video_baseUrl(imagestandingvertical)}
                            fileName={filestandingvertical}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityData.standingVerticalLeap > 0
                                ? getHandDimensionsUnitValue(
                                    strengthAndAgilityDataRanking.noStepVerticalLeapAgility
                                  )
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpNoStepVerticalLeapAgility
                            }
                            chartName={"No Step Vertical"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.noStepVerticalLeapRank
                            }/${
                              strengthAndAgilityDataRanking.tcpStandingVerticalJump ??
                              0
                            }`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Paper elevation={2} className={classes2.strengthAndAgilityContainer}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="pro-lane"
                        src={proLane}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Pro Lane Trial Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.proLaneTrialTime === null ||
                        strengthAndAgilityData.proLaneTrialTime === "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.proLaneTrialTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="pro-lane"
                        src={proLane}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        Pro Lane Total Laser Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.proLaneTotalLaserTime === null ||
                        strengthAndAgilityData.proLaneTotalLaserTime === "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.proLaneTotalLaserTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      margin: "15px 0px",
                    }}
                  >
                    <Typography
                      sx={{ flex: "0 0 25%" }}
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Position
                    </Typography>
                    {[...Array(8)].map((elem, i) => {
                      return (
                        <Typography
                          sx={{ flex: "0 0 10%" }}
                          component="span"
                          variant="subtitle2"
                          className={classes2.playerCombineValues}
                        >
                          {i + 1}
                        </Typography>
                      );
                    })}
                  </Box>
                  <Divider />
                  <Box
                    sx={{
                      display: "flex",
                      margin: "10px 0px",
                    }}
                  >
                    <Typography
                      sx={{ flex: "0 0 25%" }}
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Laser Time
                    </Typography>
                    {[...Array(8)].map((elem, i) => {
                      return (
                        <Typography
                          sx={{ flex: "0 0 10%" }}
                          component="span"
                          variant="subtitle2"
                          className={classes2.playerCombineValues}
                        >
                          {Object.keys(strengthAndAgilityData).length ? (
                            strengthAndAgilityData.proLaneLaserTimeData &&
                            strengthAndAgilityData.proLaneLaserTimeData.filter(
                              (x) => x.positionId === i + 1
                            ).length ? (
                              strengthAndAgilityData.proLaneLaserTimeData.filter(
                                (x) => x.positionId === i + 1
                              )[0].laserTime
                            ) : (
                              "--"
                            )
                          ) : (
                            <span>{loadingMessage}</span>
                          )}
                        </Typography>
                      );
                    })}
                  </Box>
                  <Divider />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angle Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "proLane",
                                "proLaneJsonData",
                                "proLaneSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                proLaneVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  proLaneVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "proLane",
                                "proLaneJsonData",
                                "proLaneSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                proLaneVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  proLaneVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {fileprolane === null || fileprolane === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(fileprolane)}
                            isAutoplay={false}
                            id="prolane"
                            image={Video_baseUrl(imageoprolane)}
                            fileName={fileprolane}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityData.proLaneTrialTime > 0
                                ? strengthAndAgilityDataRanking.prolaneAgility
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpProlaneAgility
                            }
                            chartName={"Pro Lane Agility"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.prolaneRank
                            }/${strengthAndAgilityDataRanking.tcpProlane ?? 0}`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="pro-lane"
                        src={proLane}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        3/4 Court Sprint Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.threeFourRunTime === null ||
                        strengthAndAgilityData.threeFourRunTime === "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.threeFourRunTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <Box>
                      <img
                        alt="pro-lane"
                        src={proLane}
                        height={17}
                        width={17}
                        style={{
                          color: "blue",
                          marginRight: "4px",
                        }}
                      />
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes2.playerCombineInfo}
                      >
                        3/4 Court Sprint Total Laser Time (s)
                      </Typography>
                    </Box>
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineValues}
                    >
                      {Object.keys(strengthAndAgilityData).length ? (
                        strengthAndAgilityData.threeFourRunTotalLaserTime ===
                          null ||
                        strengthAndAgilityData.threeFourRunTotalLaserTime ===
                          "" ? (
                          "--"
                        ) : (
                          strengthAndAgilityData.threeFourRunTotalLaserTime
                        )
                      ) : (
                        <span>{loadingMessage}</span>
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      margin: "15px 0px",
                    }}
                  >
                    <Typography
                      sx={{ flex: "0 0 25%" }}
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Position
                    </Typography>
                    {[...Array(4)].map((elem, i) => {
                      return (
                        <Typography
                          sx={{ flex: "0 0 10%" }}
                          component="span"
                          variant="subtitle2"
                          className={classes2.playerCombineValues}
                        >
                          {i + 1}
                        </Typography>
                      );
                    })}
                  </Box>
                  <Divider />
                  <Box
                    sx={{
                      display: "flex",
                      margin: "10px 0px",
                    }}
                  >
                    <Typography
                      sx={{ flex: "0 0 25%" }}
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Laser Time
                    </Typography>
                    {[...Array(4)].map((elem, i) => {
                      return (
                        <Typography
                          sx={{ flex: "0 0 10%" }}
                          component="span"
                          variant="subtitle2"
                          className={classes2.playerCombineValues}
                        >
                          {Object.keys(strengthAndAgilityData).length ? (
                            strengthAndAgilityData.threeFourRunLaserTimeData &&
                            strengthAndAgilityData.threeFourRunLaserTimeData.filter(
                              (x) => x.positionId === i + 1
                            ).length ? (
                              strengthAndAgilityData.threeFourRunLaserTimeData.filter(
                                (x) => x.positionId === i + 1
                              )[0].laserTime
                            ) : (
                              "--"
                            )
                          ) : (
                            <span>{loadingMessage}</span>
                          )}
                        </Typography>
                      );
                    })}
                  </Box>
                  <Divider />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    className={classes2.shuttleRunLeft}
                    mt={1}
                    sx={{
                      padding: "15px",
                      border: "2px solid lightgrey",
                      borderRadius: "5px",
                    }}
                  >
                    {/* Video Angle Stuff */}
                    <Grid container>
                      <Grid item lg={3} md={4} sm={1} xs={1}>
                        &nbsp;
                      </Grid>
                      <Grid item lg={6} md={4} sm={10} xs={10}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{ my: 1 }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "primary",
                                "threeFourthRun",
                                "threeFourRunJsonData",
                                "threeFourRunSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                threeFourthVideoAngle === "primary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Primary Video"
                              placement="top"
                            >
                              <img
                                alt="Primary Video"
                                src={
                                  threeFourthVideoAngle === "primary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleVideoAngleClick(
                                "secondary",
                                "threeFourthRun",
                                "threeFourRunJsonData",
                                "threeFourRunSecondaryJsonData"
                              )
                            }
                            sx={{
                              backgroundColor:
                                threeFourthVideoAngle === "secondary"
                                  ? "rgba(29, 66, 138, 0.2)"
                                  : "",
                            }}
                          >
                            <CustomTooltip
                              title="Secondary Video"
                              placement="top"
                            >
                              <img
                                alt="Secondary Video"
                                src={
                                  threeFourthVideoAngle === "secondary"
                                    ? PrimaryVideoImage
                                    : SecondaryVideoImage
                                }
                                width="30"
                                height="30"
                              />
                            </CustomTooltip>
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={4} sm={1} xs={1}></Grid>
                    </Grid>

                    <Grid container>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                      <Grid
                        container
                        justifyContent="center"
                        lg={10}
                        md={10}
                        sm={12}
                        xs={12}
                      >
                        {filethreefour === null || filethreefour === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <VideoJS
                            fileURL={Video_baseUrl(filethreefour)}
                            isAutoplay={false}
                            id="threefourrun"
                            image={Video_baseUrl(imagethreefour)}
                            fileName={filethreefour}
                            isSlowMo={true}
                            isDownload={true}
                          />
                        )}
                      </Grid>
                      <Hidden smDown>
                        <Grid item lg={1} md={1} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Hidden>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      sm={12}
                      xs={12}
                      justifyContent="center"
                      sx={{
                        paddingBottom: "10px",
                        paddingTop: "2px",
                      }}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid container>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                        <Grid item lg={6} md={4} sm={10} xs={10}>
                          <PlayerProfileBarChartAnthro
                            playervalue={
                              strengthAndAgilityDataRanking.threefourAgility > 0
                                ? strengthAndAgilityDataRanking.threefourAgility
                                : 0
                            }
                            groupvalue={
                              strengthAndAgilityDataRanking.grpThreefourAgility
                            }
                            chartName={"3/4 Sprint"}
                            name={strengthAndAgilityDataRanking.playerName}
                            rank={`${
                              strengthAndAgilityDataRanking.threefourRank
                            }/${
                              strengthAndAgilityDataRanking.tcpThreefour ?? 0
                            }`}
                          />
                        </Grid>
                        <Grid item lg={3} md={4} sm={1} xs={1}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        {/* Player Counter Movements charts*/}
        <Box>
          <Paper elevation={2} className={classes2.strengthAndAgilityContainer}>
            <Grid container spacing={2} sx={{ padding: "1rem" }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <img
                      alt="standin-vertical-ft"
                      src={standingVertical}
                      height={17}
                      width={17}
                      style={{
                        color: "blue",
                      }}
                    />
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Standing Vertical Counter Movements
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {counterMovement?.standingVert?.length > 0 ? (
                      <>
                        {counterMovementUrl && (
                          <Box mr={1}>
                            <a href={counterMovementUrl} target="_blank">
                              Force Plate Results
                            </a>
                          </Box>
                        )}

                        <Button
                          size="small"
                          className={classes.exportToExcel}
                          title="Export to Excel"
                          sx={{
                            border: "1px solid lightgrey",
                            boxShadow: "1px 1px 3px black",
                            minWidth: "auto !important",
                          }}
                          onClick={() =>
                            handleExportCounterMovements(counterMovement, 1)
                          }
                        >
                          <img
                            alt="pngImg"
                            src="../../../../playerProfile/excel.png"
                            width="26"
                            height="26"
                          />
                        </Button>
                      </>
                    ) : null}
                  </Box>
                </Box>
              </Grid>

              {isCounterSectionLoading ? (
                <Box sx={{ marginTop: "15vh", marginLeft: "50%" }}>
                  <CircularProgress />
                </Box>
              ) : counterMovement &&
                counterMovement?.standingVert?.length > 0 ? (
                counterMovement?.standingVert.map((attempt, index) => (
                  <>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card>
                        <CardContent>
                          {" "}
                          <PlayerProfileLineChart
                            chartName={`Attempt ${index + 1}`}
                            rawData={attempt}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                ))
              ) : (
                <Grid item lg={12} md={12} sm={12} xs={12} textAlign="center">
                  <Typography component="span" variant="subtitle2">
                    No records founds.
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Paper>

          {/* <Paper elevation={2} className={classes2.strengthAndAgilityContainer}>
            <Grid container spacing={2} sx={{ padding: "1rem" }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box display="flex" justifyContent="space-between">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="start"
                    columnGap={3}
                  >
                    <img
                      alt="max-vertical-ft"
                      src={maxVertical}
                      height={17}
                      width={17}
                      style={{
                        color: "blue",
                        marginRight: "4px",
                      }}
                    />
                    <Typography
                      component="span"
                      variant="subtitle2"
                      className={classes2.playerCombineInfo}
                    >
                      Max Vertical Counter Movements
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {counterMovement?.maxVertical?.length > 0 ? (
                      <Button
                        size="small"
                        className={classes.exportToExcel}
                        title="Export to Excel"
                        sx={{
                          border: "1px solid lightgrey",
                          boxShadow: "1px 1px 3px black",
                          minWidth: "auto !important",
                        }}
                        onClick={() =>
                          handleExportCounterMovements(counterMovement, 2)
                        }
                      >
                        <img
                          alt="pngImg"
                          src="../../../../playerProfile/excel.png"
                          width="26"
                          height="26"
                        />
                      </Button>
                    ) : null}
                  </Box>
                </Box>
              </Grid>

              {isCounterSectionLoading ? (
                <Box sx={{ marginTop: "15vh", marginLeft: "50%" }}>
                  <CircularProgress />
                </Box>
              ) : counterMovement &&
                counterMovement?.maxVertical?.length > 0 ? (
                counterMovement?.maxVertical.map((attempt, index) => (
                  <>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Card>
                        <CardContent>
                          {" "}
                          <PlayerProfileLineChart
                            chartName={`Attempt ${index + 1}`}
                            rawData={attempt}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                ))
              ) : (
                <Grid item lg={12} md={12} sm={12} xs={12} textAlign="center">
                  <Typography component="span" variant="subtitle2">
                    No records founds.
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Paper> */}
        </Box>
      </Box>
    </Box>
  );
}
